import type React from 'react';

import * as styles from './styles';

export enum MenuItemType {
  LIGHT = 'light',
  DARK = 'dark',
}

interface MenuItemProps {
  type: MenuItemType;
  active?: boolean;
  children: string | React.ReactNode;
  className?: string;
  external?: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const MenuItem: React.FC<MenuItemProps> = ({ type, active, children, className, external }: MenuItemProps) => (
  <div className={`${styles.menuItem(type, active, external)} ${className || ''}`}>{children}</div>
);
